<template>
    <component :is="component" :src="src" class="lightbox-item"></component>
</template>

<script type="text/babel">
import LightboxImage from './Image.vue';
import LightboxVideo from './Video.vue';

export const LightboxTypes = {
  Image: 1,
  Video: 2,
};

export default {
  name: 'Lightbox',
  components: {
    LightboxImage,
    LightboxVideo,
  },
  props: {
    content: {
      required: false,
    },
    type: {
      default: LightboxTypes.Image,
      required: false,
      type: Number,
    },
  },
  computed: {
    component() {
      const type = Object.entries(LightboxTypes).find((_type) => _type[1] === this.type)[0];
      return `Lightbox${type}`;
    },
    src() {
      if (this.type === LightboxTypes.Video) {
        return this.content;
      }
      return this.content.url;
    },
  },
};
</script>

<style lang="scss">
    .lightbox-item {
        display: block;
        width: 100%;
        height: auto;
        margin-bottom: .5em;
    }
</style>
